import { css } from 'styled-components';

export const typebase = css`
/*! Typebase.less v0.1.0 | MIT License */
/* Setup */
  /* Copy & Lists */
  *:first-child {
    margin-top: 0 !important;
  }
  b, strong {
    font-weight: 700;
  }
  i, em, q {
    font-style: italic;
  }

  p {
    margin-top: 1.5em;
    margin-bottom: 0;
  }
  ul,
  ol {
    margin-top: 1.5em;
    margin-bottom: 1.5em;
  }
  ul li,
  ol li {
  }
  ul ul,
  ol ul,
  ul ol,
  ol ol {
    margin-top: 0;
    margin-bottom: 0;
  }
  blockquote {
    margin-top: 1.5em;
    margin-bottom: 1.5em;
  }
  /* Headings */
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    /* Change heading typefaces here */
    font-family: sans-serif;
    margin-top: 1.5em;
    margin-bottom: 0;
    font-weight: 700;
  }
  h1 {
    font-size: 2em;
    margin-top: 3em;
  }
  h2 {
    font-size: 1.5em;
    margin-top: 3em;
  }
  h3 {
    font-size: 1.25em;
  }
  h4 {
  }
  h5 {
  }
  h6 {
  }
  /* Tables */
  table {
    margin-top: 1.5em;
    border-spacing: 0px;
    border-collapse: collapse;
  }
  table td,
  table th {
    padding: 0;
  }
  /* Code blocks */
  code {
    vertical-align: bottom;
  }

  img {
    max-width: 100%;
  }
`